import SkeletonLoader from './SkeletonLoader';

export * from './SkeletonLoader';
export default SkeletonLoader;
